module.exports = __webpack_public_path__ + "img/weddings_08_V.ba85dcb0.webp";